<template>
  <div>
    <van-nav-bar title="配资交易" class="" />
    <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24" />
        </div>
      </div>
    </van-overlay>
    <van-tabs id="activeTabBar" v-model="activeTab" style="padding-top: 3px">
      <van-tab id="topTab" href="1">
        <template #title>
          <!-- <van-row style="width: 100px">
            <van-col span="12"
              ><img
                style="width: 38px; padding-top: 5px"
                src="../assets/images/home_day1.png"
            /></van-col>
            <van-col span="12" style="padding: 5px; padding-top: 15px"
              >配资</van-col
            >
          </van-row> -->
          <div style="display: inline-flex; align-items: center;">
            <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_day1.png" alt="" />
            <p style="padding-left: 15px">配资</p>
          </div>
        </template>

        <van-tabs id="activeTabSub" v-model="activeTabSub">
          <van-tab href="1">
            <template #title>
              <span style="color: black" @click="getDayInfo">按天配资</span>
            </template>
            <van-form>
              <van-field
                v-model.number="principalDay"
                :placeholder="info.explain"
                type="digit"
                label="风险保证金"
                input-align="right"
                @keyup.native="principalChangeDay"
              />
              <van-cell>
                <template>
                  <van-row>
                    <van-col span="24">
                      <p>申请额度</p>
                    </van-col>
                  </van-row>
                  <div>
                    <van-row v-if="principalDay > 0">
                      <div>
                        <div
                          class="multiple_box"
                          v-for="(item, index) in multiple"
                          :key="index"
                        >
                          <van-col span="8" style="padding: 10px">
                            <div
                              class="multiple"
                              :class="{ capital_ul2_active: cutDay == index }"
                              @click="setCutDay(index, item)"
                              id="day"
                            >
                              <a href="javascript:void(0);">
                                <p class="multiple_detail">{{ item[0] }}倍</p>
                                <p class="multiple_rate">
                                  日利率{{ item[2] }}%
                                </p>
                                <p class="multiple_money">{{ item[3] }}港元</p>
                              </a>
                            </div>
                          </van-col>
                        </div>
                      </div>
                    </van-row>
                  </div>
                </template>
              </van-cell>
              <van-row class="rowStyle" v-if="direction_enable == 1">
                <van-col span="14" >
                  <span>配资仓位方向</span>
                </van-col>

                <van-col span="10">
                  <van-radio-group
                    :value="capital_direction"
                    direction="horizontal"
                    class="dir-group"
                    checked-color="#D02E27"
                    icon-size="15px"
                    style="width:105%; justify-content:flex-end;"
                  >
                    <van-radio :name="0" @click="toggleDirection(0)">做多交易</van-radio>
                    <van-radio :name="1" @click="toggleDirection(1)">做空交易</van-radio>
                  </van-radio-group>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>持仓时间</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>自动延期</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>风险保证金</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>{{ principalDay > 0 ? principalDay : 0 }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损警戒线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.warning).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #ff2c27">{{ parseFloat(warning).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损平仓线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.close).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #008000">{{ parseFloat(close).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>总配资资金</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span>{{ parseFloat(allMoney).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="14"
                  ><span>预存管理费</span
                  ><span style="color: #646566; font-size: 12px">
                    配资额×日利率×2</span
                  ></van-col
                >
                <van-col span="10" style="text-align: right"
                  ><span>{{ principalDay > 0 ? fee : "0.00" }}港元 / 交易日</span>
                </van-col>
              </van-row>

              <div style="background-color: #80808038">
                <div style="padding: 5px; font-size: 14px">
                  <p style="color: grey; font-size: 14px">
                    申请即默认同意
                    <span style="color: #1989fa" @click="goPage"
                      >《香港金牛证券有限公司服务协议》</span
                    >
                  </p>
                  <p style="text-align: center">
                    每个合约至少交易{{info.min_time}}个交易日<br />
                    首次申请将扣取2个交易日的管理费
                  </p>
                  <p style="text-align: center">
                    账户余额:{{ user.cash }} 代金券:
                    {{ user.voucher_management }}港元
                    <span
                      @click="getUserinfo()"
                      style="color: #1989fa; padding-left: 10px"
                      >刷新</span
                    >
                  </p>
                  <p style="text-align: center; font-size: 15px">
                    共应支付:
                    <span style="color: #ff2c27"
                      >{{ principalDay > 0 ? payMoney : "0.00" }}港元</span
                    >
                    <span v-if="payVoucher > 0"
                      >+代金券<span style="color: #ff2c27"
                        >{{ payVoucher }}港元</span
                      ></span
                    >
                  </p>
                </div>
              </div>
              <van-button
                size="small"
                box
                type="danger"
                block
                @click="operateBtnDay"
                >立即申请</van-button
              >
            </van-form>
          </van-tab>
          <!-- ================================= Week Info ========================================== -->
          <van-tab href="2">
            <template #title>
              <span style="color: black" @click="getWeekInfo">按周配资</span>
            </template>
            <van-form>
              <van-field
                v-model.number="principalWeek"
                :placeholder="info.explain"
                type="digit"
                label="风险保证金"
                input-align="right"
                @keyup.native="principalChangeWeek"
              />
              <van-cell>
                <van-row>
                  <van-col span="24">
                    <p>申请额度</p>
                  </van-col>
                </van-row>
                <div>
                  <van-row v-if="principalWeek > 0">
                    <div>
                      <div
                        class="multiple_box"
                        v-for="(item, index) in multiple"
                        :key="index"
                      >
                        <van-col span="8" style="padding: 10px">
                          <div
                            class="multiple"
                            :class="{ capital_ul2_active: cutWeek == index }"
                            @click="setCutWeek(index, item)"
                          >
                            <a href="javascript:void(0);">
                              <p class="multiple_detail">{{ item[0] }}倍</p>
                              <p class="multiple_rate">周利息{{ item[2] }}%</p>
                              <p class="multiple_money">{{ item[3] }}港元</p>
                            </a>
                          </div>
                        </van-col>
                      </div>
                    </div>
                  </van-row>
                </div>
              </van-cell>
              <van-row class="rowStyle" v-if="direction_enable == 1">
                <van-col span="14" >
                  <span>配资仓位方向</span>
                </van-col>

                <van-col span="10">
                  <van-radio-group
                    :value="capital_direction"
                    direction="horizontal"
                    class="dir-group"
                    checked-color="#D02E27"
                    icon-size="15px"
                    style="width:105%; justify-content:flex-end;"
                  >
                    <van-radio :name="0" @click="toggleDirection(0)">做多交易</van-radio>
                    <van-radio :name="1" @click="toggleDirection(1)">做空交易</van-radio>
                  </van-radio-group>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>持仓时间</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>自动延期</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>风险保证金</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>{{ principalWeek > 0 ? principalWeek : 0 }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损警戒线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.warning).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #ff2c27">{{ parseFloat(warning).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损平仓线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.close).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #008000">{{ parseFloat(close).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>总配资资金</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span>{{ parseFloat(allMoney).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="14"
                  ><span>预存管理费</span
                  ><span style="color: #646566; font-size: 12px">
                    配资额x周利率</span
                  ></van-col
                >
                <van-col span="10" style="text-align: right"
                  ><span>{{ principalWeek > 0 ? fee : "0.00" }}港元 / 周</span>
                </van-col>
              </van-row>

              <div style="background-color: #80808038">
                <div style="padding: 5px; font-size: 14px">
                  <p style="color: grey; font-size: 14px">
                    申请即默认同意
                    <span style="color: #1989fa" @click="goPage"
                      >《香港金牛证券有限公司服务协议》</span
                    >
                  </p>
                  <p style="text-align: center">
                    账户余额:{{ user.cash }} 代金券:
                    {{ user.voucher_management }}港元 (下拉刷新)
                  </p>
                  <p style="text-align: center; font-size: 15px">
                    共应支付:
                    <span style="color: #ff2c27"
                      >{{ principalWeek > 0 ? payMoney : "0.00" }}港元</span
                    >
                    <span v-if="payVoucher > 0"
                      >+代金券<span style="color: #ff2c27"
                        >{{ payVoucher }}港元</span
                      ></span
                    >
                  </p>
                </div>
              </div>
              <van-button
                size="small"
                box
                type="danger"
                block
                @click="operateBtnWeek"
                >立即申请</van-button
              >
            </van-form>
          </van-tab>

          <!-- ============================= Month Info ============================= -->
          <van-tab href="3">
            <template #title>
              <span style="color: black" @click="getMonthInfo">按月配资</span>
            </template>
            <van-form>
              <van-field
                v-model.number="principalMonth"
                :placeholder="info.explain"
                type="digit"
                label="风险保证金"
                input-align="right"
                @keyup.native="principalChangeMonth"
              />
              <van-cell>
                <van-row>
                  <van-col span="24">
                    <p>申请额度</p>
                  </van-col>
                </van-row>
                <div>
                  <van-row v-if="principalMonth > 0">
                    <div>
                      <div
                        class="multiple_box"
                        v-for="(item, index) in multiple"
                        :key="index"
                      >
                        <van-col span="8" style="padding: 10px">
                          <div
                            class="multiple"
                            :class="{ capital_ul2_active: cutMonth == index }"
                            @click="setCutMonth(index, item)"
                          >
                            <a href="javascript:void(0);">
                              <p class="multiple_detail">{{ item[0] }}倍</p>
                              <p class="multiple_rate">月利息{{ item[2] }}%</p>
                              <p class="multiple_money">{{ item[3] }}港元</p>
                            </a>
                          </div>
                        </van-col>
                      </div>
                    </div>
                  </van-row>
                </div>
              </van-cell>

              <van-row class="rowStyle" v-if="direction_enable == 1">
                <van-col span="14" >
                  <span>配资仓位方向</span>
                </van-col>

                <van-col span="10">
                  <van-radio-group
                    :value="capital_direction"
                    direction="horizontal"
                    class="dir-group"
                    checked-color="#D02E27"
                    icon-size="15px"
                    style="width:105%; justify-content:flex-end;"
                  >
                    <van-radio :name="0" @click="toggleDirection(0)">做多交易</van-radio>
                    <van-radio :name="1" @click="toggleDirection(1)">做空交易</van-radio>
                  </van-radio-group>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>持仓时间</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>自动延期</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>风险保证金</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>{{ principalMonth > 0 ? principalMonth : 0 }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损警戒线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.warning).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #ff2c27">{{ parseFloat(warning).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损平仓线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.close).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #008000">{{ parseFloat(close).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>总配资资金</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span>{{ parseFloat(allMoney).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="14"
                  ><span>预存管理费</span
                  ><span style="color: #646566; font-size: 12px">
                    配资额x月利率</span
                  ></van-col
                >
                <van-col span="10" style="text-align: right"
                  ><span
                    >{{ principalMonth > 0 ? fee : "0.00" }}港元 / 自然月</span
                  >
                </van-col>
              </van-row>

              <div style="background-color: #80808038">
                <div style="padding: 5px; font-size: 14px">
                  <p style="color: grey; font-size: 14px">
                    申请即默认同意
                    <span style="color: #1989fa" @click="goPage"
                      >《香港金牛证券有限公司服务协议》</span
                    >
                  </p>
                  <p style="text-align: center">
                    账户余额:{{ user.cash }} 代金券:
                    {{ user.voucher_management }}港元 (下拉刷新)
                  </p>
                  <p style="text-align: center; font-size: 15px">
                    共应支付:
                    <span style="color: #ff2c27"
                      >{{ principalMonth > 0 ? payMoney : "0.00" }}港元</span
                    >
                    <span v-if="payVoucher > 0"
                      >+代金券<span style="color: #ff2c27"
                        >{{ payVoucher }}港元</span
                      ></span
                    >
                  </p>
                </div>
              </div>
              <van-button
                size="small"
                box
                type="danger"
                block
                @click="operateBtnMonth"
                >立即申请</van-button
              >
            </van-form>
          </van-tab>

          <!-- ================================ Mutual Info ================== -->
          <van-tab href="4">
            <template #title>
              <span style="color: black" @click="getHuiInfo">免息配资</span>
            </template>
            <div style="background-color: #80808038">
              <div style="padding: 5px; font-size: 14px">
                <p style="font-size: 14px; padding-left: 20px">操盘类型</p>
                <van-row>
                  <van-col span="6">
                    <div style="color: red; padding-left: 20px">
                      <div
                        style="
                          border: 3px solid red;
                          padding: 5px;
                          text-align: center;
                        "
                      >
                        {{ selectShort }}
                      </div>
                    </div>
                  </van-col>
                </van-row>
                <p
                  v-for="(item, index) in explain"
                  :key="index"
                  style="padding-left: 25px; padding-right: 25px"
                >
                  <span class="red">({{ index + 1 }}){{ item }}</span>
                </p>
              </div>
            </div>
            <van-form>
              <van-field
                v-model.number="principalHui"
                :placeholder="info.explain"
                type="digit"
                label="风险保证金"
                input-align="right"
                @keyup.native="principalChangeMutual"
              />
              <van-cell>
                <van-row>
                  <van-col span="24">
                    <p>申请额度</p>
                  </van-col>
                </van-row>
                <div>
                  <van-row v-if="principalHui > 0">
                    <div>
                      <div
                        class="multiple_box"
                        v-for="(item, index) in multiple"
                        :key="index"
                      >
                        <van-col span="8" style="padding: 10px">
                          <div
                            class="multiple"
                            :class="{ capital_ul2_active: cutHui == index }"
                            @click="setCutHui(index, item)"
                          >
                            <a href="javascript:void(0);">
                              <p class="multiple_detail">{{ item[0] }}倍</p>
                              <p class="multiple_rate">免息{{ item[2] }}%</p>
                              <p class="multiple_money">{{ item[3] }}港元</p>
                            </a>
                          </div>
                        </van-col>
                      </div>
                    </div>
                  </van-row>
                </div>
              </van-cell>
              <van-row class="rowStyle" v-if="direction_enable == 1">
                <van-col span="14" >
                  <span>配资仓位方向</span>
                </van-col>

                <van-col span="10">
                  <van-radio-group
                    :value="capital_direction"
                    direction="horizontal"
                    class="dir-group"
                    checked-color="#D02E27"
                    icon-size="15px"
                    style="width:105%; justify-content:flex-end;"
                  >
                    <van-radio :name="0" @click="toggleDirection(0)">做多交易</van-radio>
                    <van-radio :name="1" @click="toggleDirection(1)">做空交易</van-radio>
                  </van-radio-group>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>持仓时间</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>最长30天</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>风险保证金</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>{{ principalHui > 0 ? principalHui : 0 }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损警戒线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.warning).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #ff2c27">{{ parseFloat(warning).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损平仓线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.close).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #008000">{{ parseFloat(close).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>总配资资金</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span>{{ parseFloat(allMoney).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="14"><span>预存管理费</span></van-col>
                <van-col span="10" style="text-align: right"
                  ><span>{{ principalHui > 0 ? fee : "0.00" }}港元 / 交易日</span>
                </van-col>
              </van-row>

              <div style="background-color: #80808038">
                <div style="padding: 5px; font-size: 14px">
                  <p style="color: grey; font-size: 14px">
                    申请即默认同意
                    <span style="color: #1989fa" @click="goPage"
                      >《香港金牛证券有限公司服务协议》</span
                    >
                  </p>
                  <p style="text-align: center">
                    账户余额:{{ user.cash }} 代金券:
                    {{ user.voucher_management }}港元 (下拉刷新)
                  </p>
                  <p style="text-align: center; font-size: 15px">
                    共应支付:
                    <span style="color: #ff2c27"
                      >{{ principalHui > 0 ? payMoneyhuHui : "0.00" }}港元</span
                    >
                    <span v-if="payVoucher > 0"
                      >+代金券<span style="color: #ff2c27"
                        >{{ payVoucher }}港元</span
                      ></span
                    >
                  </p>
                </div>
              </div>
              <van-button
                size="small"
                box
                type="danger"
                block
                @click="operateBtnMutual"
                >立即申请</van-button
              >
            </van-form>
          </van-tab>

          <!-- ================================= VIP Info ========================= -->
          <van-tab href="5">
            <template #title>
              <span style="color: black" @click="getVIPInfo">VIP配资</span>
            </template>
            <van-form>
              <van-field
                type="digit"
                label="风险保证金"
                placeholder="最少10万,最多500万,1百整倍数"
                input-align="right"
                v-model.number="principalVip"
                @keyup.native="principalChangeVip"
              />
              <van-cell>
                <van-row>
                  <van-col span="24">
                    <p>申请额度</p>
                  </van-col>
                </van-row>
                <div>
                  <van-row v-if="principalVip > 0">
                    <div>
                      <div
                        class="multiple_box"
                        v-for="(item, index) in multiple"
                        :key="index"
                      >
                        <van-col span="8" style="padding: 10px">
                          <div
                            class="multiple"
                            :class="{ capital_ul2_active: cutVip == index }"
                            @click="setCutVip(index, item)"
                          >
                            <a href="javascript:void(0);">
                              <p class="multiple_detail">{{ item[0] }}倍</p>
                              <p class="multiple_rate">月利息{{ item[2] }}%</p>
                              <p class="multiple_money">{{ item[3] }}港元</p>
                            </a>
                          </div>
                        </van-col>
                      </div>
                    </div>
                  </van-row>
                </div>
              </van-cell>
              <van-row class="rowStyle" v-if="direction_enable == 1">
                <van-col span="14" >
                  <span>配资仓位方向</span>
                </van-col>

                <van-col span="10">
                  <van-radio-group
                    :value="capital_direction"
                    direction="horizontal"
                    class="dir-group"
                    checked-color="#D02E27"
                    icon-size="15px"
                    style="width:105%; justify-content:flex-end;"
                  >
                    <van-radio :name="0" @click="toggleDirection(0)">做多交易</van-radio>
                    <van-radio :name="1" @click="toggleDirection(1)">做空交易</van-radio>
                  </van-radio-group>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>持仓时间</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>自动延期</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"><span>风险保证金</span></van-col>
                <van-col span="8" style="text-align: right"
                  ><span>{{ principalVip > 0 ? principalVip : 0 }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损警戒线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.warning).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #ff2c27">{{ parseFloat(warning).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>亏损平仓线</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金x{{parseFloat(info.close).toFixed(2)}}</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span style="color: #008000">{{ parseFloat(close).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="16"
                  ><span>总配资资金</span
                  ><span style="color: #646566; font-size: 12px">
                    配资资金+保证金</span
                  ></van-col
                >
                <van-col span="8" style="text-align: right"
                  ><span>{{ parseFloat(allMoney).toFixed(2) }}港元</span>
                </van-col>
              </van-row>
              <van-row class="rowStyle">
                <van-col span="12"
                  ><span>预存管理费</span
                  ><span style="color: #646566; font-size: 12px">
                    配资额x月利率</span
                  ></van-col
                >
                <van-col span="12" style="text-align: right"
                  ><span>{{ principalVip > 0 ? fee : "0.00" }}港元 / 自然月</span>
                </van-col>
              </van-row>

              <div style="background-color: #80808038">
                <div style="padding: 5px; font-size: 14px">
                  <p style="color: grey; font-size: 14px">
                    申请即默认同意
                    <span style="color: #1989fa" @click="goPage"
                      >《香港金牛证券有限公司服务协议》</span
                    >
                  </p>
                  <p style="text-align: center">
                    账户余额:{{ user.cash }} 代金券:
                    {{ user.voucher_management }}港元 (下拉刷新)
                  </p>
                  <p style="text-align: center; font-size: 15px">
                    共应支付:
                    <span style="color: #ff2c27"
                      >{{ principalVip > 0 ? payMoney : "0.00" }}港元</span
                    >
                    <span v-if="payVoucher > 0"
                      >+代金券<span style="color: #ff2c27"
                        >{{ payVoucher }}港元</span
                      ></span
                    >
                  </p>
                </div>
              </div>
              <van-button
                size="small"
                box
                type="danger"
                block
                @click="operateBtnVIP"
                >立即申请</van-button
              >
            </van-form>
          </van-tab>
        </van-tabs>
      </van-tab>
      <van-tab :to="{ name: 'CapitalAccount', query: { activeTab: '2' } }">
        <template #title>
          <!-- <van-row style="width: 100px">
            <van-col span="12"
              ><img
                style="width: 38px; padding-top: 5px"
                src="../assets/images/home_month1.png"
            /></van-col>
            <van-col span="12" style="padding: 5px; padding-top: 15px"
              >交易</van-col
            >
          </van-row> -->
          <div style="display: inline-flex; align-items: center">
            <img style="width: 30px; margin: 20px 0px" src="../assets/images/home_month1.png" alt="" />
            <p style="padding-left: 15px">交易</p>
          </div>
        </template>
      </van-tab>
    </van-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
  </div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  name: "CreateCapitalAccounts",
  data() {
    return {
      active: "0",
      activeTab: "0",
      activeTabSub: "0",
      tabs: ["1", "2", "3", "4", "5", "6", "7", "8"],
      user: {
        loginType: false,
        //代金券
        voucher_management: 0.0,
        //voucher ratio
        voucher_ratio: 0.0,
        //可用余额
        cash: 0.0,
      },
      info: {
        close: 0.3,
        delay: 20,
        explain: "最少2千,最多200万,1百整倍数",
        max_num: 2000000,
        min_num: 2000,
        min_time: 1,
        name: "按天配资",
        times: 100,
        warning: 0.5,
      },
      multiple: [],
      explain: [],
      multipleWeek: [],
      principalDay: "", //本金
      principalWeek: "",
      principalMonth: "",
      principalHui: "",
      principalVip: "",
      money: 0.0, //借款金额
      allMoney: 0.0, //总配资资金
      fee: 0.0, //账户管理费
      dayFee: 0.0, //按天的管理费
      warning: 0.0, //预警线
      close: 0.0,
      pitchMultiple: "", //配资利率
      cutDay: 0, //控制杠杆样式
      cutWeek: 0,
      cutMonth: 0,
      cutHui: 0,
      cutVip: 0,
      //showDayBoxes: false,
      payMoney: 0.0, //付款金额
      payVoucher: 0.0,
      payMoneyhuHui: 0.0,
      disabled: false, //我要配资按钮的 防止连点
      activeSubTab: 0,
      selectShort: "", //选择的 挥挥配资方式的 短语short
      loadingMask: false,
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      capital_direction : 0,
      direction_enable : 1,
    };
  },
  methods: {
    isActiveTab() {
      let that = this;
      if (!that.$route.query.activeTabSub) {
        that.activeTabSub = "1";
      } else {
        that.activeTabSub = that.$route.query.activeTabSub;
      }
    },
    getUserinfo() {
      let that = this;
      that.loadingMask = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.user.loginType = true;
            that.user.cash = res.data.data.cash;
            that.user.voucher_management = res.data.data.voucher_management;
            that.user.voucher_ratio = res.data.data.voucher_ratio;
            that.trade_channel_status = res.data.data.trade_channel_status;
            // that.getDayInfo();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.user.loginType = false;
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingMask = false;
        });
    },
    toggleDirection(val) {
      // if click same selected -> reset to 2 
      this.capital_direction = val;
    },
    getDayInfo() {
      let that = this;
      that.activeSubTab = 1;
      that.multiple = [];
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "day_info",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data.data;
            that.multiple = [];
            that.multiple = data.multiple;
            that.direction_enable = data.direction_capital_enable;
            $.each(that.multiple, function (index, item) {
              item.push((item[1] * 100).toFixed(2)); //百分比
              item.push(that.info.min_num * item[0]); //借款金额
            });
            that.multiple.sort(function (a, b) {
              return b[0] - a[0];
            });
            // that.principalDay = that.info.min_num; //本金
            // that.money = that.multiple[that.cutDay][3]; //借款金额
            // that.allMoney = that.principalDay + that.money; //总资金
            // that.fee = (
            //   that.multiple[that.cutDay][3] * that.multiple[that.cutDay][1]
            // ).toFixed(2); //管理费
            // that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
            // that.warning = that.principalDay * that.info.warning + that.money; //警戒线
            // that.close = that.principalDay * that.info.close + that.money; //平仓线;
            // that.pitchMultiple = that.multiple[that.cutDay][2];
            that.principalChangeDay();
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    //获取周配信息
    getWeekInfo() {
      let that = this;
      that.activeSubTab = 2;
      that.multiple = [];
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "week_info",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data.data;
            that.multiple = [];
            that.multiple = data.multiple;
            that.multiple.sort(function (a, b) {
              return b[0] - a[0];
            });
            $.each(that.multiple, function (index, item) {
              item.push((item[1] * 100).toFixed(2)); //百分比
              item.push(that.info.min_num * item[0]); //借款金额
            });
            // that.principalWeek = that.info.min_num; //本金
            // that.money = that.multiple[that.cutWeek][3]; //借款金额
            // that.allMoney = that.principalWeek + that.money; //总资金
            // that.fee = (
            //   that.multiple[that.cutWeek][3] * that.multiple[that.cutWeek][1]
            // ).toFixed(2); //管理费
            // that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
            // that.warning = that.principalWeek * that.info.warning + that.money; //警戒线
            // that.close = that.principalWeek * that.info.close + that.money; //平仓线
            // that.pitchMultiple = that.multiple[that.cutWeek][2];
            that.principalChangeWeek();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    //获取月配信息
    getMonthInfo() {
      let that = this;
      that.activeSubTab = 3;
      that.multiple = [];
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "month_info",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data.data;
            that.multiple = [];
            that.multiple = data.multiple;
            that.multiple.sort(function (a, b) {
              return b[0] - a[0];
            });
            $.each(that.multiple, function (index, item) {
              item.push((item[1] * 100).toFixed(2)); //百分比
              item.push(that.info.min_num * item[0]); //借款金额
            });
            // that.principalMonth = that.info.min_num; //本金
            // that.money = that.multiple[that.cutMonth][3]; //借款金额
            // that.allMoney = that.principalMonth + that.money; //总资金
            // that.fee = (
            //   that.multiple[that.cutMonth][3] * that.multiple[that.cutMonth][1]
            // ).toFixed(2); //管理费
            // that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
            // that.warning = that.principalMonth * that.info.warning + that.money; //警戒线
            // that.close = that.principalMonth * that.info.close + that.money; //平仓线
            // that.pitchMultiple = that.multiple[that.cutMonth][2];
            that.principalChangeMonth();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    //获取互惠信息
    getHuiInfo() {
      let that = this;
      that.activeSubTab = 4;
      that.multiple = [];
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "mutual_info",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            //var index = that.$store.state.type;
            var index = 0;
            that.allData = res.data.data;
            var data = res.data.data[index];
            var short = data.data.short;
            if (short == "T+30") {
              that.scale = "盈利5成全归您";
            } else if (short == "T+7") {
              that.scale = "盈利7成全归您";
            }
            that.explain = data.explain;
            that.selectShort = data.data.short;
            that.info = data.data;
            that.multiple = data.multiple;
            that.multiple.sort(function (a, b) {
              return b[0] - a[0];
            });
            // that.principalHui = that.info.min_num; //本金
            $.each(that.multiple, function (index, item) {
              item.push((item[1] * 100).toFixed(2)); //百分比
              item.push(that.info.min_num * item[0]); //借款金额
            });
            // that.money = that.multiple[that.cutHui][3]; //借款金额
            // that.allMoney = that.money + that.principalHui; //总配资资金
            // that.warning = that.principalHui * that.info.warning + that.money; //警戒线
            // that.close = that.principalHui * that.info.close + that.money; //平仓线
            // that.payMoneyhuHui = that.principalHui.toFixed(2); //付款金额
            that.principalChangeMutual();
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    //获取月配信息
    getVIPInfo() {
      let that = this;
      that.activeSubTab = 5;
      that.multiple = [];
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "vip_info",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data.data;
            that.multiple = data.multiple;
            that.multiple.sort(function (a, b) {
              return b[0] - a[0];
            });
            $.each(that.multiple, function (index, item) {
              item.push((item[1] * 100).toFixed(2)); //百分比
              item.push(that.info.min_num * item[0]); //借款金额
            });
            // that.principalVip = that.info.min_num; //本金
            that.money = that.multiple[that.cutVip][3]; //借款金额
            that.allMoney = that.principalVip + that.money; //总资金
            that.fee = (
              that.multiple[that.cutVip][3] * that.multiple[that.cutVip][1]
            ).toFixed(2); //管理费
            that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
            that.warning = that.principalVip * that.info.warning + that.money; //警戒线
            that.close = that.principalVip * that.info.close + that.money; //平仓线
            that.pitchMultiple = that.multiple[that.cutVip][2];
            that.principalChangeVip();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    //选择杠杆
    setCutDay(index, item) {
      let that = this;
      that.cutDay = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principalDay; //总配资资金
      that.warning = that.principalDay * that.info.warning + that.money; //警戒线
      that.close = that.principalDay * that.info.close + that.money; //平仓线
      that.pitchMultiple = item[2]; //利率
      if (that.activeSubTab == 4) {
        that.payMoneyhuHui = that.principalDay.toFixed(2); //付款金额
      }
    },
    setCutWeek(index, item) {
      let that = this;
      that.cutWeek = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principalWeek; //总配资资金
      that.warning = that.principalWeek * that.info.warning + that.money; //警戒线
      that.close = that.principalWeek * that.info.close + that.money; //平仓线
      that.pitchMultiple = item[2]; //利率
      if (that.activeSubTab == 4) {
        that.payMoneyhuHui = that.principalWeek.toFixed(2); //付款金额
      }
    },
    setCutMonth(index, item) {
      let that = this;
      that.cutMonth = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principalMonth; //总配资资金
      that.warning = that.principalMonth * that.info.warning + that.money; //警戒线
      that.close = that.principalMonth * that.info.close + that.money; //平仓线
      that.pitchMultiple = item[2]; //利率
      if (that.activeSubTab == 4) {
        that.payMoneyhuHui = that.principalMonth.toFixed(2); //付款金额
      }
    },
    setCutHui(index, item) {
      let that = this;
      that.cutHui = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principalHui; //总配资资金
      that.warning = that.principalHui * that.info.warning + that.money; //警戒线
      that.close = that.principalHui * that.info.close + that.money; //平仓线
      that.pitchMultiple = item[2]; //利率
      if (that.activeSubTab == 4) {
        that.payMoneyhuHui = that.principalHui.toFixed(2); //付款金额
      }
    },
    setCutVip(index, item) {
      let that = this;
      that.cutVip = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principalVip; //总配资资金
      that.warning = that.principalVip * that.info.warning + that.money; //警戒线
      that.close = that.principalVip * that.info.close + that.money; //平仓线
      that.pitchMultiple = item[2]; //利率
      if (that.activeSubTab == 4) {
        that.payMoneyhuHui = that.principalVip.toFixed(2); //付款金额
      }
    },
    //本金变动计算
    principalChangeDay() {
      let that = this;
      if (that.principalDay == "") {
        that.zero();
        //this.showDayBoxes = false;
      } else {
        //this.showDayBoxes = true;
        if (that.principalDay >= that.info.max_num) {
          that.principalDay = that.info.max_num;
        } else {
          that.principalDay = that.principalDay;
        }
        $.each(that.multiple, function (index, item) {
          item[3] = parseFloat(that.principalDay) * item[0];
        });
        that.money = that.multiple[that.cutDay][3]; //借款金额
        that.fee = (
          that.multiple[that.cutDay][3] * that.multiple[that.cutDay][1]
        ).toFixed(2); //管理费
        that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
        that.allMoney = that.money + that.principalDay; //总操盘资金
        that.warning = that.principalDay * that.info.warning + that.money; //警戒线
        that.close = that.principalDay * that.info.close + that.money; //平仓线
      }
    },
    principalChangeWeek() {
      let that = this;
      if (that.principalWeek == "") {
        that.zero();
        //this.showDayBoxes = false;
      } else {
        //this.showDayBoxes = true;
        if (that.principalWeek >= that.info.max_num) {
          that.principalWeek = that.info.max_num;
        } else {
          that.principalWeek = that.principalWeek;
        }
        $.each(that.multiple, function (index, item) {
          item[3] = parseFloat(that.principalWeek) * item[0];
        });
        that.money = that.multiple[that.cutWeek][3]; //借款金额
        that.fee = (
          that.multiple[that.cutWeek][3] * that.multiple[that.cutWeek][1]
        ).toFixed(2); //管理费
        that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
        that.allMoney = that.money + that.principalWeek; //总操盘资金
        that.warning = that.principalWeek * that.info.warning + that.money; //警戒线
        that.close = that.principalWeek * that.info.close + that.money; //平仓线
      }
    },
    //本金变动计算
    principalChangeMonth() {
      let that = this;
      if (that.principalMonth == "") {
        that.zero();
        //this.showDayBoxes = false;
      } else {
        //this.showDayBoxes = true;
        if (that.principalMonth >= that.info.max_num) {
          that.principalMonth = that.info.max_num;
        } else {
          that.principalMonth = that.principalMonth;
        }
        $.each(that.multiple, function (index, item) {
          item[3] = parseFloat(that.principalMonth) * item[0];
        });
        that.money = that.multiple[that.cutMonth][3]; //借款金额
        that.fee = (
          that.multiple[that.cutMonth][3] * that.multiple[that.cutMonth][1]
        ).toFixed(2); //管理费
        that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
        that.allMoney = that.money + that.principalMonth; //总操盘资金
        that.warning = that.principalMonth * that.info.warning + that.money; //警戒线
        that.close = that.principalMonth * that.info.close + that.money; //平仓线
      }
    },
    //本金变动计算
    principalChangeMutual() {
      let that = this;
      if (that.principalHui == "") {
        that.zero();
      } else {
        if (that.principalHui >= that.info.max_num) {
          that.principalHui = that.info.max_num;
        } else {
          that.principalHui = that.principalHui;
        }
        $.each(that.multiple, function (index, item) {
          item[3] = parseFloat(that.principalHui) * item[0];
        });
        that.money = that.multiple[that.cutHui][3]; //借款金额
        that.allMoney = that.money + that.principalHui; //总操盘资金
        that.warning = that.principalHui * that.info.warning + that.money; //警戒线
        that.close = that.principalHui * that.info.close + that.money; //平仓线
        that.payMoneyhuHui = that.principalHui.toFixed(2); //付款金额
        that.fee = 0.0;
      }
    },
    //本金变动计算
    principalChangeVip() {
      let that = this;
      if (that.principalVip <= 0) {
        that.zero();
        //this.showDayBoxes = false;
      } else {
        //this.showDayBoxes = true;
        if (that.principalVip >= that.info.max_num) {
          that.principalVip = that.info.max_num;
        } else {
          that.principalVip = that.principalVip;
        }
        $.each(that.multiple, function (index, item) {
          item[3] = parseFloat(that.principalVip) * item[0];
        });
        that.money = that.multiple[that.cutVip][3]; //借款金额
        that.fee = (
          that.multiple[that.cutVip][3] * that.multiple[that.cutVip][1]
        ).toFixed(2); //管理费
        that.dayFee = (parseFloat(that.fee) * 2).toFixed(2); //按天配资的管理费
        that.allMoney = that.money + that.principalVip; //总操盘资金
        that.warning = that.principalVip * that.info.warning + that.money; //警戒线
        that.close = that.principalVip * that.info.close + that.money; //平仓线
      }
    },
    zero() {
      let that = this;
      $.each(that.multiple, function (index, item) {
        item[3] = "0.00";
      });
      that.money = "0.00"; //借款金额
      that.fee = "0.00"; //管理费
      that.dayFee = "0.00"; //按天配资的管理费
      that.allMoney = "0.00"; //总操盘资金
      that.warning = "0.00"; //警戒线
      that.close = "0.00"; //平仓线
      that.payMoney = "0.00"; //付款金额
    },
    //我要配资操作
    operateBtnDay() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        if (sessionStorage.getItem("token") == null) {
          that.$toast.fail("请先登录");
        } else if (that.agree == false) {
          that.$toast.fail("请先阅读协议书");
          请先登录;
        } else {
          that.disabled = true;
          setTimeout(function () {
            that.disabled = false;
          }, 3000);
          that.loadingMask = true;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "apply_day",
                token: sessionStorage.getItem("token"),
                bond: that.principalDay,
                multiple: that.multiple[that.cutDay][0],
                direction_capital : that.capital_direction,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.principalDay = ""
                that.$toast.success({
                  message: res.data.msg,
                  onClose: function () {
                    that.$router.push("capital_account?activeTab=2");
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            }).finally(() => {
              that.loadingMask = false;
            });
        }
      }
    },
    //我要配资操作
    operateBtnWeek() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        if (sessionStorage.getItem("token") == null) {
          that.$toast.fail("请先登录");
        } else if (that.agree == false) {
          that.$toast.fail("请先阅读协议书");
        } else {
          that.disabled = true;
          setTimeout(function () {
            that.disabled = false;
          }, 3000);
          that.loadingMask = true;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "apply_week",
                token: sessionStorage.getItem("token"),
                bond: that.principalWeek,
                multiple: that.multiple[that.cutWeek][0],
                direction_capital : that.capital_direction,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.principalWeek = "";
                that.$toast.success({
                  message: res.data.msg,
                  onClose: function () {
                    that.$router.push("capital_account?activeTab=2");
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            }).finally(() => {
              that.loadingMask = false;
            });
        }
      }
    },
    //我要配资操作
    operateBtnMonth() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        if (sessionStorage.getItem("token") == null) {
          that.$toast.fail("请先登录");
        } else if (that.agree == false) {
          that.$toast.fail("请先阅读协议书");
        } else {
          that.disabled = true;
          setTimeout(function () {
            that.disabled = false;
          }, 3000);
          that.loadingMask = true;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "apply_month",
                token: sessionStorage.getItem("token"),
                bond: that.principalMonth,
                multiple: that.multiple[that.cutMonth][0],
                direction_capital : that.capital_direction,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.principalMonth = "";
                that.$toast.success({
                  message: res.data.msg,
                  onClose: function () {
                    that.$router.push("capital_account?activeTab=2");
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            }).finally(() => {
              that.loadingMask = false;
            });
        }
      }
    },
    //我要配资操作
    operateBtnMutual() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        if (sessionStorage.getItem("token") == null) {
          that.$toast.fail("请先登录");
        } else if (that.agree == false) {
          that.$toast.fail("请先阅读协议书");
        } else {
          //1、T+30 。2、 T+7
          var huiType = that.$store.state.type + 1;
          that.disabled = true;
          setTimeout(function () {
            that.disabled = false;
          }, 3000);
          //流程：请求余额  显示 余额不足弹窗 或者 确认购买弹窗
          that.loadingMask = true;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token"),
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.loadingMask = false;
                that.balance = parseFloat(res.data.data.cash);
                if (that.balance >= that.payMoneyhuHui) {
                  that.loadingMask = true;
                  //余额充足
                  that
                    .$http({
                      url: "/",
                      method: "post",
                      data: {
                        nozzle: "apply_mutual",
                        token: sessionStorage.getItem("token"),
                        bond: that.principalHui,
                        multiple: that.multiple[that.cutHui][0],
                        type: huiType, //互惠配资的方式
                        direction_capital : that.capital_direction,
                      },
                    })
                    .then(function (res) {
                      if (res.data.code == 1) {
                        that.principalHui = "";
                        that.$toast.success({
                          message: res.data.msg,
                          onClose: function () {
                            that.$router.push("capital_account?activeTab=2");
                          },
                        });
                      } else if (res.data.code == 2) {
                        that.getTradeChannel();
                      } else if (res.data.code == 0 || res.data.code == -1) {
                        that.$toast.fail(res.data.msg);
                      }
                    }).finally(() => {
                      that.loadingMask = false;
                    });
                } else {
                  //余额不足
                  that.lack = that.payMoneyhuHui - that.balance;
                  //$(".operate-fail").fadeIn(100);
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            }).finally(() => {
              that.loadingMask = false;
            });
        }
      }
    },
    //我要配资操作
    operateBtnVIP() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        if (sessionStorage.getItem("token") == null) {
          that.$toast.fail("请先登录");
        } else if (that.agree == false) {
          that.$toast.fail("请先阅读协议书");
        } else {
          that.disabled = true;
          setTimeout(function () {
            that.disabled = false;
          }, 3000);
          that.loadingMask = true;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "apply_vip",
                token: sessionStorage.getItem("token"),
                bond: that.principalVip,
                multiple: that.multiple[that.cutVip][0],
                direction_capital : that.capital_direction,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.principalVip = "";
                that.$toast.success({
                  message: res.data.msg,
                  onClose: function () {
                    that.$router.push("capital_account?activeTab=2");
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            }).finally(() => {
              that.loadingMask = false;
            });
        }
      }
    },
    // ============= get the content of trade channel popup agreement ===========

    getTradeChannel() {
      let that = this;
      Toast.loading();
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "trade_popup",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              Toast.clear();
              that.trade_rules_content_top = res.data.data.content_top;
              that.trade_rules_content_bottom = res.data.data.content_bottom;
              that.showTradeChannelPopup = true;
            } else {
              Toast.clear();
              // that.$toast.fail(res.data.msg);
            }
          })
          .catch(() => {
            Toast.clear();
          });
      }
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    goPage() {
      this.$router.push({
        path: "/protocol",
        query: { type: 14 },
      });
    },
  },
  mounted: function () {
    this.activeTabSub = this.$route.query.activeTabSub || '1';
    const handleTabInfo = () => {
      switch (this.activeTabSub) {
        case '2':
          this.getWeekInfo();
          break;
        case '3':
          this.getMonthInfo();
          break;
        case '4':
          this.getHuiInfo();
          break;
        case '5':
          this.getVIPInfo();
          break;
        case '6':
          this.getSimulateInfo();
          break;
        default:
          this.getDayInfo();
      }
    };

    if (this.$store.state.loginType) {
      this.getUserinfo();
      handleTabInfo();
    } else {
      handleTabInfo();
    }

    if (!sessionStorage.getItem("token")) {
      let that = this;
      that.$toast({
        type: "fail",
        message: "您还未登录",
        onClose: function () {
          that.$router.push("/login");
        },
      });
    }

    this.isActiveTab();
    this.activeTab = this.tabs.findIndex(
      (tab) => tab === this.$route.query.activeTab
    );
    this.activeTabSub = this.tabs.findIndex(
      (tab) => tab === this.$route.query.activeTabSub
    );
  },
  watch: {
    fee: function (value) {
      value=parseFloat(value);
      let that = this;
      that.payVoucher = 0;
      if (this.$store.state.loginType) {

        switch (that.activeSubTab) {
          case 1: //operateday
            that.payVoucher = (value*that.info.min_time)*that.user.voucher_ratio;//payable using voucher
            that.payVoucher = that.user.voucher_management >= that.payVoucher ? that.payVoucher : that.user.voucher_management;//actual paying via voucher
            that.payVoucher = Number(that.payVoucher).toFixed(2); //round for 2 decimal
            that.payMoney = Number((that.principalDay +(value*that.info.min_time)) - that.payVoucher).toFixed(2); //calculate total to pay from cash and round for 2 decimal
            break;
          case 2://operateweek
            that.payVoucher = value*that.user.voucher_ratio;//payable using voucher
            that.payVoucher = that.user.voucher_management >= that.payVoucher ? that.payVoucher : that.user.voucher_management;//actual paying via voucher
            that.payVoucher = Number(that.payVoucher).toFixed(2); //round for 2 decimal
            that.payMoney = Number((that.principalWeek + value) - that.payVoucher).toFixed(2); //calculate total to pay from cash and round for 2 decimal
            break;
          case 3://operatemonth
            that.payVoucher = value*that.user.voucher_ratio;//payable using voucher
            that.payVoucher = that.user.voucher_management >= that.payVoucher ? that.payVoucher : that.user.voucher_management;//actual paying via voucher
            that.payVoucher = Number(that.payVoucher).toFixed(2); //round for 2 decimal
            that.payMoney = Number((that.principalMonth + value) - that.payVoucher).toFixed(2); //calculate total to pay from cash and round for 2 decimal
            break;
          case 5://operatevip
            that.payVoucher = value*that.user.voucher_ratio;//payable using voucher
            that.payVoucher = that.user.voucher_management >= that.payVoucher ? that.payVoucher : that.user.voucher_management;//actual paying via voucher
            that.payVoucher = Number(that.payVoucher).toFixed(2); //round for 2 decimal
            that.payMoney = Number((that.principalVip + value) - that.payVoucher).toFixed(2); //calculate total to pay from cash and round for 2 decimal
            break;
          default:
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.rowStyle {
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}
.circle-btn {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 1px solid #808080b5;
}
.van-tabs--line .van-tabs__wrap {
  height: 58px;
}
.multiple {
  border-radius: 4px;
  border: 1px solid #98989a !important;
}
.multiple p {
  text-align: center;
  font-size: 15px;
  color: #98989a;
  margin: 0px;
}
.capital_ul2_active p {
  color: #ffffff !important;
}
.capital_ul2_active {
  background: #f56c6c;
  color: #fff !important;
  border: 1px solid #f56c6c !important;
}
.multiple_box {
  text-align: center;
}
</style>

<style>
#activeTabBar .van-tab--active {
  border: 1px solid #ee0d25 !important;
}

#activeTabBar .van-tabs__line {
  display: none;
}

#activeTabSub .van-tab--active {
  border: none !important;
  border-bottom: 1px solid #ee0d25 !important;
}

#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateCapitalAccounts.vue